import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_STORAGE_KEY = "deviceId";
const INJECTED_DEVICE_ID_KEY = "__ARGOLI_STABLE_DEVICE_ID__";

export class DeviceIdService {
  public static readonly instance = new DeviceIdService();

  private deviceId: string | null = null;

  private constructor() {}

  getDeviceId(): string {
    if (!this.deviceId) {
      this.deviceId =
        (window as Window & { __ARGOLI_STABLE_DEVICE_ID__?: string })[
          INJECTED_DEVICE_ID_KEY
        ] || null;

      if (this.deviceId) {
        localStorage.setItem(DEVICE_ID_STORAGE_KEY, this.deviceId);
      }

      if (!this.deviceId) {
        this.deviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
      }

      if (!this.deviceId) {
        if (window.crypto && window.crypto.randomUUID) {
          this.deviceId = window.crypto.randomUUID();
        } else {
          this.deviceId = uuidv4();
        }
        localStorage.setItem(DEVICE_ID_STORAGE_KEY, this.deviceId);
      }
    }

    return this.deviceId;
  }
}
